document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.explain-toggle').forEach(btn => {
    btn.addEventListener('click', () => {
      const body = btn.nextElementSibling;
      body.classList.toggle('is-open');
      btn.textContent = body.classList.contains('is-open')
        ? '解説を閉じる'
        : '解説を見る';
    });
  });
});
